import axios from 'axios';

const api = axios.create({
  //baseURL: 'http://localhost:3000',
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:3020/api',
});

api.interceptors.request.use(config => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  response => response,
  error => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      window.location.reload(); 
    }
    return Promise.reject(error);
  }
);

export default api;